/* eslint-disable max-len */
import 'react';

let index = 0;

const SheetSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;
    const id = `SheetSvg-1-${timeStamp}`;
    const id2 = `SheetSvg-2-${timeStamp}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
            <defs>
                <linearGradient
                    x1="15.825%"
                    y1="1.015%"
                    x2="84.756%"
                    y2="46.931%"
                    id={id}
                >
                    <stop stopColor="#84E2A1" offset="0%" />
                    <stop stopColor="#6EDBA4" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="81.112%"
                    id={id2}
                >
                    <stop stopColor="#FFF" stopOpacity={0.96} offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.8} offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M1.857 2.1h22.286v22.286H1.857z" />
                <path
                    d="M0 1.247C0 .558.558 0 1.247 0h12.055a5.278 5.278 0 015.278 5.278v14.514a2.494 2.494 0 01-2.493 2.494H2.494A2.494 2.494 0 010 19.792V1.247z"
                    fill={`url(#${id})`}
                    transform="translate(3.714 2.1)"
                />
                <path
                    d="M14.392 12.933v2.98c0 .649-.525 1.174-1.174 1.174h-2.98v-4.154h4.154zm-5.885 0v4.154h-2.98a1.174 1.174 0 01-1.174-1.174v-2.98h4.154zm0-5.884v4.153H4.353v-2.98c0-.648.526-1.173 1.174-1.173h2.98zm4.711 0c.649 0 1.174.525 1.174 1.173v2.98h-4.154V7.05h2.98z"
                    fill={`url(#${id2})`}
                    transform="translate(3.714 2.1)"
                />
            </g>
        </svg>
    );
};
export default SheetSvg;
